import { toast } from "react-toastify";
import { API_path } from "./apiPath";
import axiosInstance from "./axios";

const getSupplierData = async (orgId) => {
  let resSupplier = [];
  try {
    const response = await axiosInstance.get(API_path.getAllCustomers, {
      params: {
        orgId: orgId,
        customerType:"SUPPLIER"
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resSupplier = responseDate.paramObjectsMap.customerVO;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resSupplier;
};

const getCustomerData = async (orgId) => {
  let resCustomer = [];
  try {
    const response = await axiosInstance.get(API_path.getAllCustomers, {
      params: {
        orgId: orgId,
        customerType:"PATIENT"
      },
    });
    const responseDate = response.data;
    if (responseDate && responseDate.status) {
      // toast.success(responseDate.paramObjectsMap.message);
      resCustomer = responseDate.paramObjectsMap.customerVO;
    } else {
      toast.error(responseDate.paramObjectsMap.errorMessage);
    }
  } catch (error) {
    console.log(error);
  }
  return resCustomer;
};

export { getSupplierData,getCustomerData };
